import {
  ChangeDetectorRef,
  Component,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {DynamicComponent} from "@app/data/dashboard/interfaces/dynamic-component.interface";
import {KlReportFilter2Component} from "@app/modules/shared/components/kl-report-filter2/kl-report-filter2.component";
import {PrimengLocal} from "@app/modules/shared/constants/primeng-local";
import {ColumnsDto} from "@app/modules/shared/model/columns.dto";
import {CompanyDto} from "@app/modules/shared/model/company.dto";
import {ReportTypeEnum} from "@app/modules/shared/model/report-type.enum";
import {ApiService} from "@app/modules/shared/services/base/api.service";
import {ConvertIsoDateService} from "@app/modules/shared/services/convert-iso-date.service";
import {
  ExplorerService,
  ModalConfig,
} from "@app/modules/shared/services/explorer.service";
import {KlAlertService} from "@app/modules/shared/services/message/alert.service";
import {KlSweetAlertService} from "@app/modules/shared/services/message/kl-sweet-alert.service";
import {TranslateService} from "@app/modules/shared/services/translate/translate.service";
import {UtilService} from "@app/modules/shared/services/util.service";
import {GridSettings} from "@syncfusion/ej2-pivotview/src/pivotview/model/gridsettings";
import {findIndex} from "lodash";
import {BsModalRef} from "ngx-bootstrap/modal";
import {forkJoin, of, Subscription} from "rxjs";
import {catchError, finalize} from "rxjs/operators";
import {SpeCodeListComponent} from "../../../application-params/specode/components/specode-list/specode-list.component";
import {MaterialListComponent} from "../../material/components/material-list/material-list.component";
import * as wjCore from "wijmo/wijmo";
import {NgForm} from "@angular/forms";
import {CurrentAccountListComponent} from "../../../finance-management/current-account/components/current-account-list/current-account-list.component";
import {CustomerListComponent} from "../../../shipping-management/customer/components/customer-list/customer-list.component";

declare const $: any;

interface ReportObject {
  filter: any;
  parameters: any;
  close?: any;
  query: {
    paging?: {
      limit?: number;
      offset?: number;
      fetch?: string;
    };
    sort?: Array<{
      name: string;
      desc: boolean;
    }>;
  };
}

@Component({
  selector: "kl-license-documents-report",
  templateUrl: "./license-documents-report.component.html",
  styleUrls: ["./license-documents-report.component.scss"],
})
export class LicenseDocumentsReportComponent implements OnInit, OnDestroy {
  @Input() entity;
  @ViewChild(forwardRef(() => KlReportFilter2Component), {static: true})
  klReportFilter: KlReportFilter2Component;
  @ViewChild("filterForm") filterForm: NgForm;
  locale = "TR";
  tunnel: Subscription;
  dateFormatString: string;
  entryName: string;
  currentReport: any;
  loadReport = false;
  saveForm = false;
  alertShow = false;
  alertMessage = "";
  selectedReportFilterValues: Array<any> = [];
  designList = [];
  wareHouseList = [];
  materialCodeExpressionValue: any;
  materialDescriptionExpressionValue: any;
  customerNameExpressionValue: any;
  taxNumExpressionValue: any;
  licenseTypeCodeExpressionValue: any;
  licenseKeyExpressionValue: any;
  mainLicenseKeyExpressionValue: any;

  sourceData = {
    report_fields: [
      {
        customer_name: "",
        tax_num: "",
        license_code: "",
        license_description: "",
        license_type_code: "",
        license_key: "",
        main_license_key: "",
      },
    ],
  };

  private _customerNameValue: any;
  set customerNameValue(value: any) {
    this._customerNameValue = value;
    if (value) {
      const payload = {
        label: "material_name",
        key: "customerNameValue",
        value: value,
      };
      this.insertOrUpdate(
        this.selectedReportFilterValues,
        {label: "material_name"},
        payload
      );
    } else {
      this._customerNameValue = null;
      const index = findIndex(this.selectedReportFilterValues, {
        label: "material_name",
      });
      if (index >= 0) {
        this.selectedReportFilterValues.splice(index, 1);
      }
    }
  }

  get customerNameValue() {
    return this._customerNameValue;
  }

  private _taxNumValue: any;
  set taxNumValue(value: any) {
    this._taxNumValue = value;
    if (value) {
      const payload = {
        label: "tax_num",
        key: "taxNumValue",
        value: value,
        accessor: "type",
      };
      this.insertOrUpdate(
        this.selectedReportFilterValues,
        {label: "tax_num"},
        payload
      );
    } else {
      this._taxNumValue = null;
      const index = findIndex(this.selectedReportFilterValues, {
        label: "tax_num",
      });
      if (index >= 0) {
        this.selectedReportFilterValues.splice(index, 1);
      }
    }
  }

  get taxNumValue() {
    return this._taxNumValue;
  }

  private _licenseTypeCodeValue: any;
  set licenseTypeCodeValue(value: any) {
    this._licenseTypeCodeValue = value;
    if (value) {
      const payload = {
        label: "product_number",
        key: "licenseTypeCodeValue",
        value: value,
        accessor: "type",
      };
      this.insertOrUpdate(
        this.selectedReportFilterValues,
        {label: "product_number"},
        payload
      );
    } else {
      this._licenseTypeCodeValue = null;
      const index = findIndex(this.selectedReportFilterValues, {
        label: "product_number",
      });
      if (index >= 0) {
        this.selectedReportFilterValues.splice(index, 1);
      }
    }
  }

  get licenseTypeCodeValue() {
    return this._licenseTypeCodeValue;
  }

  private _materialCodeValue: any;
  set materialCodeValue(value: any) {
    if (value) {
      this._materialCodeValue = value;
      const payload = {
        label: "material_code",
        key: "materialCodeValue",
        value: value,
      };
      this.insertOrUpdate(
        this.selectedReportFilterValues,
        {label: "material_code"},
        payload
      );
    } else {
      const index = findIndex(this.selectedReportFilterValues, {
        label: "material_code",
      });
      this._materialCodeValue = null;
      if (index >= 0) {
        this.selectedReportFilterValues.splice(index, 1);
      }
    }
  }

  get materialCodeValue() {
    return this._materialCodeValue;
  }

  private _materialDescriptionValue: any;
  set materialDescriptionValue(value: any) {
    if (value) {
      this._materialDescriptionValue = value;
      const payload = {
        label: "material_description",
        key: "materialDescriptionValue",
        value: value,
      };
      this.insertOrUpdate(
        this.selectedReportFilterValues,
        {label: "material_description"},
        payload
      );
    } else {
      this._materialDescriptionValue = null;
      const index = findIndex(this.selectedReportFilterValues, {
        label: "material_description",
      });
      if (index >= 0) {
        this.selectedReportFilterValues.splice(index, 1);
      }
    }
  }

  get materialDescriptionValue() {
    return this._materialDescriptionValue;
  }

  private _licenseKeyValue: any;
  set licenseKeyValue(value: any) {
    if (value) {
      this._licenseKeyValue = value;
      const payload = {
        label: "lecense_key",
        key: "licenseKeyValue",
        value: value,
      };
      this.insertOrUpdate(
        this.selectedReportFilterValues,
        {label: "lecense_key"},
        payload
      );
    } else {
      this._licenseKeyValue = null;
      const index = findIndex(this.selectedReportFilterValues, {
        label: "lecense_key",
      });
      if (index >= 0) {
        this.selectedReportFilterValues.splice(index, 1);
      }
    }
  }

  get licenseKeyValue() {
    return this._licenseKeyValue;
  }

  private _mainLicenseKeyValue: any;
  set mainLicenseKeyValue(value: any) {
    this._mainLicenseKeyValue = value;
    if (value) {
      const payload = {
        label: "main_license_key",
        key: "mainLicenseKeyValue",
        value: value,
      };
      this.insertOrUpdate(
        this.selectedReportFilterValues,
        {label: "main_license_key"},
        payload
      );
    } else {
      this._mainLicenseKeyValue = null;
      const index = findIndex(this.selectedReportFilterValues, {
        label: "main_license_key",
      });
      if (index >= 0) {
        this.selectedReportFilterValues.splice(index, 1);
      }
    }
  }

  get mainLicenseKeyValue() {
    return this._mainLicenseKeyValue;
  }

  MaterialComponent = MaterialListComponent;
  currentAccountListComponent = CurrentAccountListComponent;
  CustomerListComponent = CustomerListComponent;
  expressionOptions = [
    {
      label: this.translateService.instant("LIKE"),
      value: "LIKE",
    },
    {
      label: this.translateService.instant("EQ"),
      value: "EQ",
    },
    {
      label: this.translateService.instant("START_WITH"),
      value: "START_WITH",
    },
  ];
  materialExpressionOptions = [
    {
      label: this.translateService.instant("LIKE"),
      value: "LIKE",
    },
    {
      label: this.translateService.instant("NOT_LIKE"),
      value: "NOT_LIKE",
    },
    {
      label: this.translateService.instant("EQ"),
      value: "EQ",
    },
    {
      label: this.translateService.instant("NOT_EQ"),
      value: "NOT_EQ",
    },
    {
      label: this.translateService.instant("START_WITH"),
      value: "START_WITH",
    },
    {
      label: this.translateService.instant("END_WITH"),
      value: "END_WITH",
    },
    {
      label: this.translateService.instant("GT"),
      value: "GT",
    },
    {
      label: this.translateService.instant("GE"),
      value: "GE",
    },
    {
      label: this.translateService.instant("LT"),
      value: "LT",
    },
    {
      label: this.translateService.instant("LE"),
      value: "LE",
    },
  ];

  // report fields
  filter: any;
  url: string;
  working_period_id: string;
  company: CompanyDto;
  columns: Array<ColumnsDto> = [
    {
      header: "customer_name",
      binding: "customer.description",
      width: 450,
      visible: true,
    },
    {
      header: "tax_num",
      binding: "customer.tax_num",
      width: 220,
      visible: true,
    },
    {
      header: "license_code",
      binding: "material.code",
      width: 170,
      visible: true,
    },
    {
      header: "license_description",
      binding: "material.description",
      width: 220,
      visible: true,
    },
    {
      header: "license_type_code",
      binding: "material.product_number",
      width: 170,
      visible: true,
    },
    {
      header: "license_key",
      binding: "license_key",
      width: 400,
      visible: true,
    },
    {
      header: "main_license_key",
      binding: "main_license_key",
      width: 400,
      visible: true,
    },
    {
      header: "installation_user2",
      binding: "installation_user",
      width: 400,
      visible: true,
    },
    {
      header: "installation_date",
      binding: "license_history.modified_date",
      format: "date-time",
      width: 200,
      visible: true,
    },
  ];

  pivotRows = [
    {
      name: "material_code",
      caption: this.translateService.instant("material_code"),
    },
    {
      name: "material_description",
      caption: this.translateService.instant("material_description"),
    },
  ];
  data: any;
  report_type: ReportTypeEnum.GRID;
  parentModuleName = "MATERIAL_MANAGEMENT";
  moduleName = "MATERIAL_STATUS_REPORT";
  key: string;
  type: string;
  public gridSettings: GridSettings;
  showReport = false;

  constructor(
    private explorerService: ExplorerService,
    private alertService: KlSweetAlertService,
    private utilService: UtilService,
    private klAlertService: KlAlertService,
    private dateConvert: ConvertIsoDateService,
    private cd: ChangeDetectorRef,
    private translateService: TranslateService,
    private apiService: ApiService
  ) {
    this.dateFormatString = utilService.dateFormatString
      .toLowerCase()
      .replace("yy", "");
    this.tunnel = this.explorerService.transferState$.subscribe((state) => {
      switch (state.state) {
        case "MATERIAL_STATUS_REPORT_DETAIL_FILTER_MATERIAL_CODE_CURRENT_ITEM":
          this.materialCodeValue = state.payload.code;
          this.cd.markForCheck();
          break;
        case "MATERIAL_STATUS_REPORT_DETAIL_FILTER_MATERIAL_DESCRIPTION_CURRENT_ITEM":
          this.materialDescriptionValue = state.payload.description;
          this.cd.markForCheck();
          break;
        case "MATERIAL_STATUS_REPORT_DETAIL_FILTER_CUSTOMER_NAME_CURRENT_ITEM":
          this.customerNameValue = state.payload.description;
          this.cd.markForCheck();
          break;
      }
    });
  }

  ngOnInit() {
    this.customerNameExpressionValue = "LIKE";
    this.taxNumExpressionValue = "LIKE";
    this.materialCodeExpressionValue = "LIKE";
    this.materialDescriptionExpressionValue = "LIKE";
    this.licenseTypeCodeExpressionValue = "LIKE";
    this.licenseKeyExpressionValue = "LIKE";
  }

  showLoadingFunc(loadingText: string) {
    this.klReportFilter.showLoadingFunc(loadingText);
  }

  hideLoadingFunc() {
    this.klReportFilter.hideLoadingFunc();
  }

  selectReport(report) {
    this.currentReport = report;
  }

  setModalWithF10(elementId: string, event: KeyboardEvent) {
    if (event.key === "F10") {
      event.preventDefault();
      document.getElementById(elementId)?.click();
    }
  }

  setModal(
    title: string,
    stateSelector: string,
    template: any,
    modalId: string,
    haveFilter = false,
    multiSelect = false
  ) {
    const modalConfig = <ModalConfig>{
      title: title,
      stateSelector: "MATERIAL_STATUS_REPORT_DETAIL_FILTER_" + stateSelector,
      childTemplate: <DynamicComponent>{
        mode: "DIALOG",
        modalId: modalId,
        dblSelect: true,
        multiSelectCollection: multiSelect
          ? "gridComponent.collectionView"
          : "",
        template: template,
        multiSelect: multiSelect,
        templateContext: {
          filter: haveFilter ? {type: "MATERIAL_CARD"} : {},
        },
      },
    };
    this.explorerService.openModal(modalConfig);
  }

  deleteFromValues(event) {
    this.selectedReportFilterValues.splice(event.index, 1);
    this[event.item.key] = null;
  }

  deleteSavedReport(event) {
    this.alertService.alertDelete(
      {
        title: "warning",
        text: "entry_must_be_delete",
        customClass: "kl-alert",
        showCloseButton: false,
      },
      () => {
        this.apiService.deleteData("design", event.item.id).subscribe(
          () => {
            this.clearAll();
            this.designList.splice(event.index, 1);
            this.cd.markForCheck();
          },
          (errDeletePreference) => this.handleError(errDeletePreference)
        );
      }
    );
  }

  applyReport(event) {
    const preparedReport: ReportObject = this.prepareReportObject();
    if (preparedReport.parameters.length > 0) {
      if (Object.keys(preparedReport.filter.material).length < 1) {
        delete preparedReport.filter.material;
      }
      if (preparedReport.hasOwnProperty("close")) {
        delete preparedReport.close;
      }
      if (event.report_type === "monitor_report") {
        const newWindow: any = window.open("report-viewer", "_blank");
        newWindow.apiUrl = "product-license/license-report";
        newWindow.currentReport = this.currentReport;
        newWindow.filter = preparedReport;
      } else {
        this.gridSettings = {
          columnWidth: 140,
        } as GridSettings;
        this.report_type = event.report_type;
        if (this.report_type === ReportTypeEnum.GRID) {
          this.type = "GRID_DESIGN";
          this.key = "MATERIAL_STATUS_REPORT";
        } else if (this.report_type === ReportTypeEnum.PIVOT) {
          this.type = "PIVOT_DESIGN";
          this.key = "MATERIAL_STATUS_REPORT";
        } else {
          this.type = "EXCELSHEET_DESIGN";
          this.key = "MATERIAL_STATUS_REPORT";
        }
        this.url = "product-license/license-report";
        this.filter = preparedReport;
        setTimeout(() => {
          if (this.klReportFilter.showReport) {
            this.klReportFilter.klReportComponent.reload();
          } else {
            this.klReportFilter.showReport = true;
          }
        }, 40);
      }
      // this.explorerService.closeModal(this);
    } else {
      this.alertShow = true;
      this.alertMessage = "at_least_1_filter_must_be_entered";

      setTimeout(() => {
        this.alertShow = false;
        this.alertMessage = undefined;
      }, 3000);
    }
  }

  clearAll() {
    delete this.currentReport;
    for (let i = 0; i < this.selectedReportFilterValues.length; i++) {
      this[this.selectedReportFilterValues[i].key] = null;
      i = i - 1;
    }
    this.selectedReportFilterValues = [];
  }

  insertOrUpdate(array: any[], meta: any, value: any) {
    const index = findIndex(array, meta);
    if (index >= 0) {
      array.splice(index, 1);
      array.push(value);
      return;
    }
    return array.push(value);
  }

  closeReport() {
    const preparedReport = this.prepareReportObject();
    Object.assign(preparedReport, {close: true});
    this.explorerService.transferState({
      state: this.entity.state + "_DETAIL_FILTER",
      payload: preparedReport,
    });
    this.explorerService.closeModal(this);
  }

  prepareReportObject() {
    const filterObject = Object.create(null);
    filterObject["material"] = Object.create(null);
    filterObject["customer"] = Object.create(null);
    const parametersObject = [];
    if (this.materialCodeValue) {
      filterObject["material"]["code"] = this.materialCodeValue;
      parametersObject.push({
        name: "code",
        expression: {
          operator: this.materialCodeExpressionValue,
        },
      });
    }
    if (this.materialDescriptionValue) {
      filterObject["material"]["description"] = this.materialDescriptionValue;
      parametersObject.push({
        name: "description",
        expression: {operator: this.materialDescriptionExpressionValue},
      });
    }
    if (this.customerNameValue) {
      filterObject["customer"]["description"] = this.customerNameValue;
      parametersObject.push({
        name: "customer_name",
        expression: {operator: this.customerNameExpressionValue},
      });
    }
    if (this.taxNumValue) {
      filterObject["customer"]["tax_num"] = this.taxNumValue;
      parametersObject.push({
        name: "tax_num",
        expression: {operator: this.taxNumExpressionValue},
      });
    }
    if (this.licenseTypeCodeValue) {
      filterObject["material"]["product_number"] = this.licenseTypeCodeValue;
      parametersObject.push({
        name: "product_number",
        expression: {operator: this.licenseTypeCodeExpressionValue},
      });
    }
    if (this.licenseKeyValue) {
      filterObject["license_key"] = this.licenseKeyValue;
      parametersObject.push({
        name: "license_key",
        expression: {operator: this.licenseKeyExpressionValue},
      });
    }
    if (this.mainLicenseKeyValue) {
      filterObject["main_license_key"] = this.mainLicenseKeyValue;
      parametersObject.push({
        name: "main_license_key",
        expression: {operator: this.mainLicenseKeyExpressionValue},
      });
    }

    // Object.assign(filterObject, {
    //   compress: "YES",
    //   company: {
    //     id: this.utilService.selectedCompany().id,
    //   },
    //   working_period: {
    //     id: this.utilService.selectedWorkingPeriod().id,
    //   },
    // });
    return Object.assign(
      {},
      {filter: filterObject},
      {parameters: parametersObject},
      {
        query: {
          paging: {
            limit: 1000000,
            offset: 0,
            fetch: "EAGER",
          },
          sort: [
            {
              name: "id",
              desc: true,
            },
          ],
        },
      }
    );
  }

  include(value, string) {
    if (value) {
      return value.includes(string);
    } else {
      return false;
    }
  }

  handleError(error) {
    this.alertShow = true;
    this.alertMessage = this.utilService.alertErrorMessage(error);
    this.hideLoadingFunc();
    return of(null);
  }

  ngOnDestroy() {
    this.tunnel.unsubscribe();
  }
}
